import type { UiNode, UiNodeImageAttributes } from "@ory/kratos-client";
import type React from "react";

interface Props {
	node: UiNode;
	attributes: UiNodeImageAttributes;
}

export const NodeImage: React.FC<Props> = ({ node, attributes }) => {
	return (
		<div className="text-center" key={attributes.id}>
			<img
				data-testid={`node/image/${attributes.id}`}
				src={attributes.src}
				alt={node.meta.label?.text}
				width={attributes.width}
				height={attributes.height}
				className="mt-6 inline-block"
			/>
		</div>
	);
};
